module.exports = __webpack_public_path__ + "img/card-customers.d6e94fe4.jpg";